import { formatCurrency, UnitedStatesState } from '@shared';
import {
  consumerQuotePremium,
  paymentScheduleOfQuote,
  type ConsumerQuote,
} from '@shared/consumerPlan';

export function money(value: number): string {
  return formatCurrency(Math.round(value));
}

// From the largest magnitude down: amounts at or above `atLeast` round to the nearest `unit`.
const ESTIMATE_ROUNDING = [
  { atLeast: 10_000, unit: 1000 },
  { atLeast: 1000, unit: 100 },
  { atLeast: 100, unit: 10 },
] as const;

/** Rounds estimates so they don't read as more precise than they are. */
export function approxMoney(value: number): string {
  const magnitude = Math.abs(value);
  const unit = ESTIMATE_ROUNDING.find(({ atLeast }) => magnitude >= atLeast)?.unit ?? 1;
  return money(Math.round(value / unit) * unit);
}

export function hoursPerWeek(value: number, unit = 'hrs/week'): string {
  const hours = Math.round(value);
  return hours === 0 ? `0 ${unit}` : `~${hours} ${unit}`;
}

export const PAYMENT_SCHEDULE_LABELS: Record<ConsumerPaymentSchedule, string> = {
  ongoing: 'Monthly, ongoing',
  tenPay: 'Annually for 10 years',
  singlePay: 'Pay once',
};

const PREMIUM_SUFFIX: Record<ConsumerPaymentSchedule, string> = {
  ongoing: 'per month, ongoing',
  tenPay: 'per year for 10 years',
  singlePay: 'once',
};

export function premiumText(quote: ConsumerQuote): string {
  const schedule = paymentScheduleOfQuote(quote) ?? 'ongoing';
  return `${money(consumerQuotePremium(quote))} ${PREMIUM_SUFFIX[schedule]}`;
}

export function stateName(abbreviation: string | null): string {
  return (abbreviation && UnitedStatesState[abbreviation]?.stateName) || 'your state';
}
